import _ from "lodash";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { Icon, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import StorageService from "services/StorageService";

function UserLogout() {
  const user = StorageService.getUser();

  const tooltipText = user ? `${user.role.name}: ${user.email}` : "";
  return (
    <Link to="/login">
      <SoftBox
        border="2px solid dark"
        borderRadius="lg"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        mt={0}
      >
        <SoftBox ml="auto" lineHeight={0}>
          <Tooltip title={tooltipText} placement="bottom">
            <SoftButton variant="outlined" color="secondary" size="small" iconOnly circular>
              <Icon sx={{ cursor: "pointer" }}>person</Icon>
            </SoftButton>
          </Tooltip>
        </SoftBox>
      </SoftBox>
    </Link>
  );
}

export default UserLogout;
